import { hjGetCookie, hjSetCookie } from '@hotjar/webapp/utils/cookies';

const knowledgeBaseCookieKey = '_hjKB';

type StateHistoryItem = {
  name: string;
  timestamp: number;
};

export type KnowledgeBaseCookieValue = {
  stateHistory: StateHistoryItem[];
  latestSite: number;
};

export const readKnowledgeBaseCookieJson = (): KnowledgeBaseCookieValue => {
  let valueJson;
  const valueString = hjGetCookie(knowledgeBaseCookieKey) ?? '';
  try {
    valueJson = JSON.parse(valueString);
  } catch (e) {
    // If parsing fails we don't care that much, just clear it and start from scratch.
    valueJson = {
      stateHistory: [],
      latestSite: null,
    };
  }
  return valueJson;
};

export const constructKnowledgeBaseCookieValue = (
  currentState: StateHistoryItem,
  latestSite: number | null,
  currentValue: KnowledgeBaseCookieValue,
): KnowledgeBaseCookieValue => {
  const value: KnowledgeBaseCookieValue = JSON.parse(JSON.stringify(currentValue));

  // Add the new state to the front of the array and remove the oldest if history is full.
  if (value.stateHistory.length >= 3) {
    value.stateHistory.pop();
  }
  value.stateHistory.unshift({
    name: currentState.name,
    timestamp: new Date().getTime(),
  });

  if (latestSite !== null) {
    value.latestSite = latestSite;
  }

  return value;
};

/**
 * The _hjKB cookie is used to pass user insights to the Zendesk Knowledge Base in order
 * to offer the user more relevant help.
 * @param currentState The current state the app is in.
 */
export const setKnowledgeBaseCookie = (
  siteID: number | null,
  currentState: StateHistoryItem,
): void => {
  const currentValue = readKnowledgeBaseCookieJson();
  const value = constructKnowledgeBaseCookieValue(currentState, siteID, currentValue);
  hjSetCookie(knowledgeBaseCookieKey, JSON.stringify(value), 365, 'hotjar.com');
};
